import { QueryClient } from '@tanstack/react-query';

import { isApiErrorStatus } from 'shared/client/apiClient';

let queryClient: QueryClient | undefined = undefined;

/**
 * Get a QueryClient instance for use in router loaders.
 * Loaders run outside React context, so we use a singleton pattern.
 */
export function getQueryClient() {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 5 * 60 * 1000, // 5 minutes
          // Auth / not-found errors are permanent. Retrying them just delays the UI by
          // ~7s (default 3 retries + exponential backoff) — and for endpoints guarded
          // by PBI 527401 it would delay LockedMessage rendering by that long. Transient
          // errors (network, 5xx) still get React Query's default 3 retries.
          retry: (failureCount, error) => {
            if (isApiErrorStatus(error, 401) || isApiErrorStatus(error, 403) || isApiErrorStatus(error, 404)) {
              return false;
            }
            return failureCount < 3;
          }
        }
      }
    });
  }
  return queryClient;
}
